import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },
  {
    path: '/header',
    name: 'Header',
    component: () => import('../views/Header.vue')
  },
  {
    path: '/footer',
    name: 'Footer',
    component: () => import('../views/Footer.vue')
  },
  {
    path: '/',
    name: 'Index',
    component: () => import('../views/Home.vue'),
    meta:{
      isBanner:true,
    }
  },
  {
    path: '/list/:menuId',
    name: 'List',
    component: () => import('../views/List.vue'),
  },
  {
    path: '/listCenter/:menuId',
    name: 'ListCenter',
    component: () => import('../views/ListCenter.vue'),
  },
  {
    path: '/listTeach/:menuId',
    name: 'ListTeach',
    component: () => import('../views/ListTeach.vue'),
  },
  {
    path: '/list/:menuId',
    name: 'List',
    component: () => import('../views/List.vue'),
  },
  {
    path: '/detail/:contentId',
    name: 'Detail',
    component: () => import('../views/Detail.vue'),
  },
  {
    path: '/search/:searchInput',
    name: 'Search',
    component: () => import('../views/Search.vue'),
  },
  {
    path: '/BigEquipment',
    name: 'BigEquipment',
    component: () => import('../views/BigEquipment.vue')
  },
  {
    path: '/labOpenApply',
    name: 'labOpenApply',
    component: () => import('../views/labOpenApply.vue')
  },
  {
    //用户反馈
    path: '/feedBack',
    name: 'feedBack',
    component: () => import('../views/feedBack.vue')
  },
  {
    //预约审核
    path: '/insAppointmentAudit',
    name: 'insAppointmentAudit',
    component: () => import('../views/insAppointmentAudit.vue')
  },
  // 手持端登录
  {
    path:'/mobileLogin',
    name: 'mobileLogin',
    component: () => import('../views/Mobile/components/login.vue')
  },
  {
    path:'/touGe',
    name:'touGe',
    component:()=>import('../views/TouGe.vue'),
    meta: {
      isBanner: true
    }
  }
]
//阻止冲突点击报错
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})
// router.beforeEach((to, from, next) => {
//   // 滚动到页面顶部
//   window.scrollTo(0, 0);
//   next();
// });
router.beforeEach((to, from, next) => {
  document.getElementById('app').scrollTop=0
  next()
})
export default router
